<template>
  <div>
    <popup
      ref="popup"
      round
      v-model="show"
      position="bottom"
      :close-on-click-overlay="false"
      :lazy-render="false"
    >
      <div class="popup-title">
        <span class="popup-cancel" @click="popupCancel">取消</span>
        <span class="popup-title-text">选择出生日期</span>
        <span class="popup-confirm" @click="popupConfirm">确定</span>
      </div>
      <div class="switch-gy">
        <span class="switch-gy-tilte">选择公历或阴历</span>
        <div class="switch">
          <span :class="{ action: type == 0 }" @click="type = 0">公历</span>
          <span :class="{ action: type == 1 }" @click="type = 1">阴历</span>
        </div>
      </div>

      <datetime-picker
        ref="datetime"
        :show-toolbar="false"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        visible-item-count="5"
      />
    </popup>
  </div>
</template>

<script>
/**
@description:选择时间组件
@createTime:2021-09-21
@create:wq
*/
import { Popup, DatetimePicker } from "vant";

export default {
  name: "",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    lunar: {
      type: Number,
      default: 0,
    },
    date: {
      type: String,
      default: "请选择出生年月日",
    },
  },
  model: {
    prop: "show",
    event: "changeShow",
  },

  components: { Popup, DatetimePicker },
  data() {
    return {
      sex: 1,
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(),
      type: this.lunar,
    };
  },
  computed: {},
  watch: {
    show() {
      this.type = this.lunar;
      if (this.date !== "请选择出生年月日") {
        const arr = this.date.split("-");
        this.$refs.datetime.getPicker().setValues(arr);
      }
    },
  },
  mounted() {},
  created() {},
  methods: {
    popupCancel() {
      this.$emit("changeShow", false);
    },
    popupConfirm() {
      const date = this.$refs.datetime.getPicker().getValues().join("-");
      this.$emit("changeShow", false);
      this.$emit("confirm", { lunar: this.type, date: date });
    },
  },
};
</script>
<style lang="scss" scoped>
.popup-title {
  width: 100%;
  height: 50px;
  background: #f6f6f6;
  font-size: 15px;
  font-weight: 500;
  color: #333333;
  box-sizing: border-box;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .popup-cancel {
    color: #666666;
  }
  .popup-title-text {
    font-weight: bold;
  }
  .popup-confirm {
  }
}
.switch-gy {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e3e3e3;
  box-sizing: border-box;
  padding: 0 15px;

  .switch-gy-tilte {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }
  .switch {
    width: 120px;
    height: 30px;
    background: #f6f6f6;
    border-radius: 15px;
    overflow: hidden;
    display: flex;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    border: 1px solid #e3e3e3;
    > span {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .action {
      color: #ffffff;
      background: #34c290;
    }
  }
}
</style>
